export default "__VITE_ASSET__Bj_$hqaV__"